const axios = require("axios");
const config = require("./config");
const helpers = require("../../helpers");
const instance = axios.create({
    baseURL: config.crossOrigin,
    timeout: config.timeout,
});

const loadAll = ({ href = "", filter = {} }) => {
    let p = new Promise((resolve) => {
        instance.post(href, filter).then((res) => {
            helpers.html.log.success(`api.node.cross.${href.substring(1, href.length).replace(/\//g, ".")}`, res.data);
            if (res.status === 200) resolve(res.data);
        }).catch((error) => {
            console.log(error);
            resolve({ error });
        });
    });

    return p;
};

const loadBlob = ({ href = "", filter = {} }) => {
    let p = new Promise(async (resolve) => {
        let options = { responseType: "blob" };
        instance.post(href, filter, options).then(async (res) => {
            let text = `api.node.cross.${href.substring(1, href.length).replace(/\//g, ".")}`;
            if (res.status !== 200) {
                helpers.html.log.error(text, res);
                resolve(res.data);
                return;
            };
            let blodData = res.data;
            helpers.html.log.success(text, blodData);
            resolve({ is_success: true, data: blodData });
        }).catch((error) => {
            console.log(error);
            resolve({ error });
        });
    });

    return p;
};

module.exports = {
    mario: {
        google: {
            search: (filter) => loadAll({ href: "/node/mario/google/search", filter }),
            region: (filter) => loadAll({ href: "/node/mario/google/region", filter }),
        },
    },
    export: {
        excel: (filter) => loadBlob({ href: "/node/export/excel", filter }),
    },
};




// WEBPACK FOOTER //
// src/utils/api/node/api.node.cross.js